import React from "react"

import dayGridPlugin from "@fullcalendar/daygrid"
import listPlugin from "@fullcalendar/list"
import FullCalendar from "@fullcalendar/react"

import useIsMobile from "hooks/useIsMobile"

export type CalendarEvent = {
  id: string
  title: string
  start: string
  end: string
  backgroundColor: string
  borderColor: string
}

type SessionCalendarProps = {
  events: CalendarEvent[]
  setDateRange: (range: { startDate: string; endDate: string }) => void
}

const SessionCalendar: React.FC<SessionCalendarProps> = ({
  events,
  setDateRange,
}) => {
  const isMobile = useIsMobile()

  return (
    <FullCalendar
      plugins={[dayGridPlugin, listPlugin]}
      initialView={isMobile ? "listMonth" : "dayGridMonth"}
      events={events}
      eventDisplay="block"
      buttonText={{ today: "Today" }}
      datesSet={info =>
        setDateRange({ startDate: info.startStr, endDate: info.endStr })
      }
      eventTimeFormat={{
        hour: "numeric",
        minute: "2-digit",
        meridiem: "short",
        omitZeroMinute: true,
      }}
    />
  )
}

export default SessionCalendar
